// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/lib/supabase';

const SUPABASE_URL = "https://xqvnipvpyqidfnbvjhsr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhxdm5pcHZweXFpZGZuYnZqaHNyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ0MzY4NjMsImV4cCI6MjA3MDAxMjg2M30.bGnuLkOGWkemVt8-Xj4eECybGEfFMTd90Ufs_wrc4qY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});